<template>
  <eg-b-modal
    id="verify-password-reset-modal"
    :title="$t('auth.passwordReset.checkEmail')"
    size="md"
    scrollable
    no-close-on-backdrop
    no-close-on-esc
    @show="onShow"
  >
    <div>
      <div class="mb-3">
        {{ $t("auth.emailSentMessage") }}
      </div>

      <eg-b-form-group
        id="code-group"
        :label="$t('auth.passwordReset.verificationCode')"
        label-for="code-input"
      >
        <eg-b-form-input
          id="code-input"
          ref="code"
          v-model="code"
          type="text"
          name="code"
          :state="code.length === 6 || null"
          :placeholder="$t('auth.passwordReset.verificationCode')"
          class="mb-3"
        />
      </eg-b-form-group>
      <eg-b-form-group
        id="password-group"
        :label="$t('auth.passwordReset.newPassword')"
        label-for="password-input"
      >
        <eg-b-form-input
          id="password-input"
          ref="passwordInput"
          v-model="password"
          type="password"
          :state="password.length >= 8 || null"
          :placeholder="$t('auth.passwordReset.enterPassword')"
          required
        ></eg-b-form-input>
      </eg-b-form-group>
      <eg-b-form-group
        id="confirm-password-group"
        :label="$t('auth.passwordReset.confirmPassword')"
        label-for="confirm-password-input"
      >
        <eg-b-form-input
          id="confirm-password-input"
          v-model="confirmedPassword"
          type="password"
          :state="passwordState"
          :placeholder="$t('auth.passwordReset.enterConfirmed')"
          required
        ></eg-b-form-input>
        <eg-b-form-invalid-feedback id="input-confirmed">
          {{ $t("auth.passwordReset.passwordMismatch") }}
        </eg-b-form-invalid-feedback>
      </eg-b-form-group>
    </div>

    <template #modal-footer>
      <eg-b-button variant="info" @click="resetPassword">{{
        $t("auth.passwordReset.resetButton")
      }}</eg-b-button>
    </template>
  </eg-b-modal>
</template>

<script>
export default {
  data() {
    return {
      code: "",
      password: "",
      confirmedPassword: "",
      clerk: null,
    };
  },

  computed: {
    passwordState() {
      return this.confirmedPassword.length === 0
        ? null
        : this.password.length >= 8 && this.password === this.confirmedPassword;
    },
  },

  created() {
    this.clerk = this.$getClerk();
  },

  methods: {
    onShow() {
      this.code = "";
    },

    async resetPassword() {
      try {
        const clientProvider =
          await this.clerk.client.signIn.attemptFirstFactor({
            strategy: "reset_password_email_code",
            code: this.code,
            password: this.password,
          });
        this.clerk.checkStatus({ clientProvider });
      } catch (error) {
        this.$showToastError(error.message, { title: this.$t("common.error") });
        this.code = "";
      }
    },
  },
};
</script>
